import React, { useState } from "react";
import {
  Button,
  TextField,
  InputAdornment,
  StandardTextFieldProps,
} from "@mui/material";
import { Visibility, VisibilityOff, Lock } from "@mui/icons-material";

export interface PasswordFieldProps
  extends Omit<StandardTextFieldProps, "type" | "InputProps"> {
  showPasswordIcon?: boolean;
  testeid?: string;
  customStyles?: React.CSSProperties;
  customClassName?: string;
  isLogin?: boolean;
}

const PasswordField: React.FC<PasswordFieldProps> = ({
  value = "",
  onChange,
  fullWidth = false,
  showPasswordIcon = false,
  testeid = "password",
  customStyles,
  customClassName,
  isLogin = false,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(showPasswordIcon);

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <TextField
      {...rest}
      data-testid={testeid}
      value={value}
      onChange={onChange}
      fullWidth={fullWidth}
      variant={isLogin ? "outlined" : "standard"}
      type={showPassword ? "text" : "password"}
      style={{
        backgroundColor: "#FFF", // Fundo semelhante ao da imagem
        ...customStyles,
      }}
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={{
        disableUnderline: true,
        className: customClassName,
        startAdornment: isLogin ? (
          <InputAdornment position="start">
            <Lock style={{ color: "#E2A354" }} />
          </InputAdornment>
        ) : null,
        endAdornment: (
          <InputAdornment position="end">
            <Button
              onClick={handleTogglePasswordVisibility}
              style={{ minWidth: 24, padding: 4 }}
            >
              {showPassword ? (
                <Visibility fontSize="small" />
              ) : (
                <VisibilityOff fontSize="small" />
              )}
            </Button>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PasswordField;
